import { render, staticRenderFns } from "./GlasswareSample.vue?vue&type=template&id=5ff23e11&scoped=true&"
import script from "./GlasswareSample.vue?vue&type=script&lang=js&"
export * from "./GlasswareSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff23e11",
  null
  
)

export default component.exports